export const copyText = (text, callback) => {
  navigator.clipboard.writeText(text).then(() => {
    callback && callback()
  }).catch((err) => console.error(err))
}
